import type { Route } from 'vue-router'
import { RouteParamValueT } from '~/mixins/routeQueryMixin'

export type RouteNavigationParams = Partial<Pick<Route, 'name' | 'params' | 'query'>>

export const QUERY_PARAM_ARRAY_SPLITTER = ','

export function encodeRoute({ name, params, query }: RouteNavigationParams = {}): string {
  if (!name) {
    return ''
  }

  return encodeURIComponent(
    JSON.stringify({
      name,
      params,
      query
    })
  )
}

export function extractRouteParams({
  name,
  params,
  query
}: RouteNavigationParams = {}): RouteNavigationParams | null {
  if (!name) {
    return null
  }

  return { name, params, query }
}

export function getFilterArray(fltrStr: RouteParamValueT, arraySplitter?: string): string[] {
  return fltrStr?.toString().split(arraySplitter ?? QUERY_PARAM_ARRAY_SPLITTER) ?? []
}
